"use client";
import React from 'react';
import { motion } from 'framer-motion';

const CLASH = 'var(--font-clash), "Clash Display", sans-serif';
const MANROPE = 'var(--font-manrope), Manrope, sans-serif';
const LIME = '#ceff1a';

export default function CROWhatIs() {
    return (
        <section className="relative overflow-hidden pt-20 pb-16 md:pt-28 md:pb-20 px-6 md:px-16 lg:px-24" style={{ background: '#080400', borderTopLeftRadius: '80px', borderTopRightRadius: '80px' }}>
            <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle, rgba(165,180,252,1) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="max-w-[800px] mx-auto relative z-10 flex flex-col gap-6">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: LIME, fontFamily: CLASH }}
                >
                    The Basics
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-3xl md:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: CLASH, color: '#fbfdfd' }}
                >
                    What Is Conversion Rate Optimization?
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex flex-col gap-5"
                >
                    <p className="text-base md:text-lg leading-relaxed" style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}>
                        Conversion Rate Optimization (CRO) is the systematic process of improving a website or digital journey so a higher proportion of relevant visitors complete a desired action.
                    </p>
                    <p className="text-base md:text-lg leading-relaxed" style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}>
                        That action could be a purchase, enquiry, demo request, signup, booking or another business-defined conversion.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
